import { Injectable } from '@angular/core';
import { IUser, IUserUpdate } from '@core/interfaces/user.interface';
import { UserService } from '@core/services/user.service';
import { ComponentStore } from '@ngrx/component-store';
import { EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

interface IUserState {
  user: IUser | null;
  loading: boolean;
  error: string | null;
  userSubmitLoading: boolean;
}

const initialState: IUserState = {
  error: null,
  loading: false,
  user: null,
  userSubmitLoading: false,
};

@Injectable()
export class ProfileStore extends ComponentStore<IUserState> {
  public readonly user$ = this.selectSignal((state: IUserState) => state.user);
  public readonly loading$ = this.selectSignal((state: IUserState) => state.loading);
  public readonly error$ = this.selectSignal((state: IUserState) => state.error);

  public readonly updateUser = this.effect((userUpdate$: Observable<{ id: string; userUpdate: IUserUpdate }>) => {
    return userUpdate$.pipe(
      tap(() => this.patchState({ error: null, loading: true })),
      switchMap(({ id, userUpdate }) =>
        this.userService.updateUser(id, userUpdate).pipe(
          tap((user: IUser) => {
            this.patchState({ loading: false, user });
          }),
          catchError(() => {
            this.patchState({
              error: 'Failed to update user',
              loading: false,
            });

            return EMPTY;
          }),
        ),
      ),
    );
  });

  constructor(private readonly userService: UserService) {
    super(initialState);
  }
}
